"use client";

import { useEffect, useState } from "react";
import { useFormStore } from "@/core/stores";
import { handleReadMyForms } from "@/features/form-functions";

export function useReadMyForms() {
  const [loading, setLoading] = useState(false);
  const { forms, setForms } = useFormStore();
  const [error, setError] = useState<string | null>(null);

  const readForms = async () => {
    setLoading(true);
    try {
      const { data, error } = await handleReadMyForms();
      if (error) return;
      setForms(data);
    } catch (e) {
      const error = e as Error;
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    readForms();
  }, []);

  return {
    loading,
    error,
    forms,
    readForms,
  };
}
